<script setup>
import { useI18n } from '@/Composables/i18n.js';

const { transWithDefault } = useI18n();

defineProps({
    businessAreas: {
        type: Array,
        required: false,
        default: () => [],
    },
    advertorial: {
        type: Boolean,
        required: false,
        default: false,
    },
    type: {
        type: String,
        required: false,
        default: null,
    },
    attendeeCount: {
        type: Number,
        required: false,
        default: null,
    },
    showOnMobile: {
        type: Boolean,
        required: false,
        default: false,
    },
    isInactive: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>

<template>
    <div
        class="flex flex-col sm:flex-row justify-between gap-y-4 gap-x-2"
        :class="{ 'py-0.5': !showOnMobile }"
    >
        <div class="flex flex-wrap gap-x-4 gap-y-2">
            <div
                v-if="businessAreas && businessAreas.length > 0"
                class="inline-flex space-x-2"
                :class="[isInactive ? 'text-gray-500' : 'text-deep-teal-700', { 'hidden lg:flex': !showOnMobile }]"
            >
                <span
                    v-for="businessArea in businessAreas.filter(businessArea => businessArea.icon)"
                    :key="businessArea.id"
                    :title="businessArea.name"
                    class="inline-block size-7 rounded-full p-1"
                    :class="[isInactive ? 'bg-deep-teal-25' : 'bg-deep-teal-100']"
                    v-html="businessArea.icon"
                />
            </div>

            <div
                v-if="advertorial"
                class="inline-flex self-center font-bold text-xs/4 text-white rounded-full py-[3px] px-2"
                :class="[isInactive ? 'bg-deep-teal-500' : 'bg-deep-teal-700']"
            >
                {{ $t('components.card.advertorial') }}
            </div>

            <div
                v-if="attendeeCount"
                class="inline-flex self-center items-center font-bold text-xs/tight rounded-full py-px px-2 gap-x-1.5"
                :class="[isInactive ? 'bg-deep-teal-25 text-gray-500' : 'bg-deep-teal-100 text-deep-teal-700']"
            >
                <span>{{ attendeeCount }}</span>

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="shrink-0 size-5 stroke-current text-deep-teal-700"
                    fill="none"
                >
                    <path
                        stroke="fillCurrent"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        d="M6.285 11.955c1.469 0 2.66-1.212 2.66-2.708 0-1.496-1.191-2.709-2.66-2.709-1.47 0-2.66 1.213-2.66 2.709s1.19 2.708 2.66 2.708Z"
                    />
                    <path
                        stroke="fillCurrent"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        d="M3 15.393c0-1.907 1.52-3.455 3.393-3.455 1.873 0 3.393 1.548 3.393 3.455M13.07 10.417c1.47 0 2.66-1.212 2.66-2.708C15.73 6.213 14.54 5 13.07 5c-1.469 0-2.66 1.213-2.66 2.709s1.191 2.708 2.66 2.708Z"
                    />
                    <path
                        stroke="fillCurrent"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        d="M10.53 11.702a3.363 3.363 0 0 1 2.649-1.299c1.873 0 3.393 1.548 3.393 3.455"
                    />
                </svg>
            </div>

            <div
                v-if="type"
                class="inline-flex self-center font-bold text-xs/4 rounded-full py-[3px] px-2"
                :class="[isInactive ? 'bg-deep-teal-25 text-gray-500' : 'bg-deep-teal-100 text-deep-teal-700']"
            >
                {{ transWithDefault(`enums.collectionType.${type}`, type) }}
            </div>
        </div>
    </div>
</template>
